var React = require('react');

function ErrorIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1024 -2359)"},[React.createElement("g",{"transform":"translate(1024 2359)","fill":"none","stroke":"#b90101","strokeWidth":"1.5","key":0},[React.createElement("rect",{"width":"26","height":"26","rx":"13","stroke":"none","key":0}),React.createElement("rect",{"x":"0.75","y":"0.75","width":"24.5","height":"24.5","rx":"12.25","fill":"none","key":1})]),React.createElement("text",{"transform":"translate(1035 2377.151)","fill":"#b90101","fontSize":"15","fontFamily":"FuturaPT-DemiBold, Futura PT","fontWeight":"300","letterSpacing":"0.1em","key":1},React.createElement("tspan",{"x":"0","y":"0"},"!"))]));
}

ErrorIcon.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = ErrorIcon;

ErrorIcon.default = ErrorIcon;
